import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../../config/NaeSSchema";

class UserModel extends Model {
  static reducer(action, UserModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.User.schema:
        action.payload.forEach((payload) => {
          const dbData = UserModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          UserModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
UserModel.modelName = "UserModel";

UserModel.fields = {
  id: attr(),
};

export default UserModel;